import { PayloadAction, createSlice } from "@reduxjs/toolkit";
// import { API_CENTER } from "../../../services/api/api";
// import { message } from "antd";

interface IOrganization {
  id: number;
  inn: string;
  ogrn: string;
  name: string;
  phone_number: string | null;
  email: string | null;
  snils: string | null;
  created_at: string;
  updated_at: string;
}

export interface IClient {
  id: number;
  organization_id: number;
  role_id: number;
  surname: string;
  name: string;
  patronymic: string | null;
  email: string;
  image_path: string;
  inn: string;
  phone_number: string | null;
  type: string;
  is_banned: boolean;
  is_referral?: boolean;
  organization: IOrganization | null;
  is_enabled: boolean;
}

interface IClientSelected {
  id?: number;
  full_name: string;
  organization_name: string;
  inn: string;
  ogrn: string;
  email: string;
  phone_number: string;
  is_enable?: boolean;
  is_referral?: boolean;
}

interface IClientFormInput {
  id?: number;
  surname: string;
  name: string;
  patronymic: string | null;
  email: string;
  inn: string;
  phone_number: string | null;
  organization_inn: string | null;
  organization_ogrn: string | null;
  organization_name: string | null;
  organization_email: string | null;
  organization_phone_number: string | null;
  is_enable?: boolean;
}

interface IClientForm {
  CLIENT_FORM_DISABLED: boolean;
  CLIENT_FORM_INITIAL: IClientFormInput;
  CLIENT_FORM_TYPE: "EDIT" | "INFO" | "ADD";
}

interface IListClientState {
  LIST_CLIENT_ACTIVE: IClient[];
  LIST_CLIENT_ARCHIVE: IClient[];
  SELECTED_CLIENT: IClientSelected;
  CLIENT_FORM: IClientForm;
}

const initialState: IListClientState = {
  LIST_CLIENT_ACTIVE: [],
  LIST_CLIENT_ARCHIVE: [],
  SELECTED_CLIENT: {
    full_name: "",
    organization_name: "",
    inn: "",
    ogrn: "",
    email: "",
    phone_number: "",
  },
  CLIENT_FORM: {
    CLIENT_FORM_DISABLED: true,
    CLIENT_FORM_INITIAL: {} as IClientFormInput,
    CLIENT_FORM_TYPE: "INFO",
  },
};

// interface API_LIST_CLIENT_EDIT_REQUEST {
//   user: {
//     id: number;
//     surname: string;
//     name: string;
//     patronymic: string;
//     email: string;
//     inn: string | number;
//     phone_number: string;
//   };
//   organization: {
//     inn: string | number;
//     ogrn: string;
//     name: string;
//     phone_number?: string;
//     email?: string;
//     snils?: string;
//   } | null;
// }

const setClientData = (client: IClient) => {
  const nameParts = [client.surname, client.name, client.patronymic].filter(
    Boolean
  );
  const full_name = nameParts.join(" ");

  let inn = "";
  let ogrn = "";
  let organization_name = "";

  if (client.organization) {
    inn = client.organization.inn ? client.organization.inn : "";
    ogrn = client.organization.ogrn ? client.organization.ogrn : "-";
    organization_name = client.organization.name
      ? client.organization.name
      : "";
  } else if (client.inn) {
    inn = client.inn;
  }
  return {
    id: client.id,
    full_name: `${full_name}`,
    organization_name: `${organization_name}`,
    inn: inn,
    ogrn: `${ogrn}`,
    email: `${client.email ? client.email : ""}`,
    phone_number: `${client.phone_number}`,
    is_enable: client.is_enabled,
    is_referral: client?.is_referral,
  };
};

const setFormClientData = (client: IClient): IClientFormInput => {
  return {
    id: client.id ?? 0,
    surname: client.surname ?? null,
    name: client.name ?? null,
    patronymic: client.patronymic ?? null,
    email: client.email ?? null,
    inn: client.inn ?? "",
    phone_number: client.phone_number ?? null,
    organization_inn: client.organization?.inn ?? null,
    organization_ogrn: client.organization?.ogrn ?? null,
    organization_name: client.organization?.name ?? null,
    organization_email: client.organization?.email ?? null,
    organization_phone_number: client.organization?.phone_number ?? null,
  };
};

// const API = new API_CENTER();
// export const API_LIST_CLIENT_ARCHIVE = createAsyncThunk<
//   { client_id: number; is_enabled: boolean },
//   { client_id: number; is_enabled: boolean },
//   {
//     rejectValue: string;
//   }
// >(
//   "listClientSlice/API_LIST_CLIENT_ARCHIVE",
//   async (value, { rejectWithValue }) => {
//     const response = await API.GET_API(
//       `user/${value.client_id}/enable`,
//       "PATCH",
//       {
//         is_enabled: value.is_enabled,
//       }
//     );
//     if (response.success) {
//       return { client_id: value.client_id, is_enabled: value.is_enabled };
//     } else {
//       return rejectWithValue(response);
//     }
//   }
// );

// export const API_LIST_CLIENT_EDIT = createAsyncThunk<
//   IClient,
//   API_LIST_CLIENT_EDIT_REQUEST,
//   {
//     rejectValue: string;
//   }
// >(
//   "listClientSlice/ API_LIST_CLIENT_EDIT",
//   async (value, { rejectWithValue }) => {
//     const response = await API.GET_API(`user/${value.user.id}`, "PUT", {
//       user: {
//         surname: value.user.surname,
//         name: value.user.name,
//         patronymic: value.user.patronymic,
//         email: value.user.email,
//         inn: value.user.inn,
//         phone_number: value.user.phone_number,
//       },
//       organization: {
//         inn: value.organization?.inn,
//         ogrn: value.organization?.ogrn,
//         name: value.organization?.name,
//         phone_number: value.organization?.phone_number,
//         email: value.organization?.email,
//         snils: value.organization?.snils,
//       },
//     });
//     if (response.success) {
//       return response.data;
//     } else {
//       return rejectWithValue(response);
//     }
//   }
// );

// страница списка клиентов для админов
const listClientSlice = createSlice({
  name: "LIST_CLIENT_SLICE",
  initialState: initialState,
  reducers: {
    // обновить лист клиентов
    UP_DATE_LIST_CLIENT: (state, actions: PayloadAction<IClient[], string>) => {
      const listClient = actions.payload.reduce(
        (acc, obj) => {
          if (obj.is_enabled === true) {
            acc.active.push(obj);
          } else {
            acc.archive.push(obj);
          }
          return acc;
        },
        { active: [], archive: [] } as {
          active: IClient[];
          archive: IClient[];
        }
      );
      state.LIST_CLIENT_ACTIVE = listClient.active;
      state.LIST_CLIENT_ARCHIVE = listClient.archive;
      if (listClient.active.length > 0) {
        state.SELECTED_CLIENT = setClientData(listClient.active[0]);
      }
    },
    // изменить выбранного клиента
    CHANGE_SELECTED_CLIENT: (
      state,
      actions: PayloadAction<IClient, string>
    ) => {
      if (actions.payload) {
        state.SELECTED_CLIENT = setClientData(actions.payload);
      }
    },
    // изменить начальное значение формы вывода информации о клиенте
    CHANGE_CLIENT_FORM_INITIAL: (
      state,
      actions: PayloadAction<IClient, string>
    ) => {
      if (actions.payload) {
        state.CLIENT_FORM.CLIENT_FORM_INITIAL = setFormClientData(
          actions.payload
        );
      }
    },
    // изменить доступ к полям формы
    CHANGE_CLIENT_FORM_DISABLE: (
      state,
      actions: PayloadAction<boolean, string>
    ) => {
      state.CLIENT_FORM.CLIENT_FORM_DISABLED = actions.payload;
    },
    // изменить тип формы информации клиента
    CHANGE_CLIENT_FORM_TYPE: (
      state,
      actions: PayloadAction<"EDIT" | "INFO" | "ADD", string>
    ) => {
      state.CLIENT_FORM.CLIENT_FORM_TYPE = actions.payload;
    },
    // обновить список активных и архивных клиентов
    UP_DATE_LIST_CLIENT_STORE: (
      state,
      actions: PayloadAction<IClient[], string>
    ) => {
      if (actions.payload) {
        const listClient = actions.payload.reduce(
          (acc, obj) => {
            if (obj.is_enabled === true) {
              acc.active.push(obj);
            } else {
              acc.archive.push(obj);
            }
            return acc;
          },
          { active: [], archive: [] } as {
            active: IClient[];
            archive: IClient[];
          }
        );

        state.LIST_CLIENT_ACTIVE = listClient.active;
        state.LIST_CLIENT_ARCHIVE = listClient.archive;
        if (listClient.active.length > 0) {
          state.SELECTED_CLIENT = setClientData(listClient.active[0]);
          state.CLIENT_FORM.CLIENT_FORM_INITIAL = setFormClientData(
            listClient.active[0]
          );
        }
      }
    },
    // добавить клиента в архив
    CLIENT_ARCHIVE: (state, actions) => {
      const updatedLestClient = state.LIST_CLIENT_ACTIVE.concat(
        state.LIST_CLIENT_ARCHIVE
      ).map((client: IClient) => {
        if (client.id === actions.payload.client_id) {
          return {
            ...client,
            is_enabled: actions.payload.is_enabled,
          };
        }
        return client;
      });

      const listClient = updatedLestClient.reduce(
        (acc: { active: IClient[]; archive: IClient[] }, client: IClient) => {
          if (client.is_enabled === true) {
            acc.active.push(client);
          } else {
            acc.archive.push(client);
          }
          return acc;
        },
        { active: [], archive: [] } as {
          active: IClient[];
          archive: IClient[];
        }
      );
      state.LIST_CLIENT_ACTIVE = listClient.active;
      state.LIST_CLIENT_ARCHIVE = listClient.archive;
      if (!listClient.active) {
        state.SELECTED_CLIENT = {
          id: 0,
          full_name: "",
          organization_name: "",
          inn: "",
          ogrn: "",
          email: "",
          phone_number: "",
        };
      }
    },
    // изменить клиента
    CLIENT_EDIT: (state, actions) => {
      state.SELECTED_CLIENT = setClientData(actions.payload);
      state.LIST_CLIENT_ACTIVE = state.LIST_CLIENT_ACTIVE.map(
        (client: IClient) =>
          client.id === actions.payload.id ? actions.payload : client
      );
      state.CLIENT_FORM.CLIENT_FORM_INITIAL = setFormClientData(
        actions.payload
      );
    },
  },
  // extraReducers: (builder) => {
  //   builder.addCase(API_LIST_CLIENT_ARCHIVE.fulfilled, (state, actions) => {
  //     const updatedLestClient = state.LIST_CLIENT_ACTIVE.concat(
  //       state.LIST_CLIENT_ARCHIVE
  //     ).map((client) => {
  //       if (client.id === actions.payload.client_id) {
  //         return {
  //           ...client,
  //           is_enabled: actions.payload.is_enabled,
  //         };
  //       }
  //       return client;
  //     });

  //     const listClient = updatedLestClient.reduce(
  //       (acc, client) => {
  //         if (client.is_enabled === true) {
  //           acc.active.push(client);
  //         } else {
  //           acc.archive.push(client);
  //         }
  //         return acc;
  //       },
  //       { active: [], archive: [] } as {
  //         active: IClient[];
  //         archive: IClient[];
  //       }
  //     );
  //     state.LIST_CLIENT_ACTIVE = listClient.active;
  //     state.LIST_CLIENT_ARCHIVE = listClient.archive;
  //   });
  //   builder.addCase(API_LIST_CLIENT_ARCHIVE.rejected, (state, actions) => {
  //     const errorMessage = actions.error.message;
  //     message.error(errorMessage);
  //   });
  //   builder.addCase(API_LIST_CLIENT_EDIT.fulfilled, (state, actions) => {
  //     state.SELECTED_CLIENT = setClientData(actions.payload);
  //     state.LIST_CLIENT_ACTIVE = state.LIST_CLIENT_ACTIVE.map((agent) =>
  //       agent.id === actions.payload.id ? actions.payload : agent
  //     );
  //     state.CLIENT_FORM.CLIENT_FORM_INITIAL = setFormClientData(
  //       actions.payload
  //     );
  //   });
  //   builder.addCase(API_LIST_CLIENT_EDIT.rejected, (state, actions) => {
  //     const errorMessage = actions.error.message;
  //     message.error(errorMessage);
  //   });
  // },
});

export const {
  UP_DATE_LIST_CLIENT,
  CHANGE_SELECTED_CLIENT,
  UP_DATE_LIST_CLIENT_STORE,
  CHANGE_CLIENT_FORM_INITIAL,
  CHANGE_CLIENT_FORM_DISABLE,
  CHANGE_CLIENT_FORM_TYPE,
  CLIENT_ARCHIVE,
  CLIENT_EDIT,
} = listClientSlice.actions;

export default listClientSlice.reducer;
